import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    token: Cookies.get("token") || null, // JWT from backend, persisted in cookies
    email: localStorage.getItem("email") || null,
    firstName: localStorage.getItem("firstName") || null,
    isAdmin: localStorage.getItem("isAdmin") === "true",
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload.token;
            state.email = action.payload.email;
            state.firstName = action.payload.firstName;
            if (action.payload.isAdmin !== undefined) {
                state.isAdmin = action.payload.isAdmin;
            }
        },
        clearToken: (state) => {
            state.token = null;
            state.email = null;
            state.firstName = null;
            state.isAdmin = false;
        }
    }
});

export const { setToken, clearToken } = userSlice.actions;
export default userSlice.reducer;
